import axios from "axios";
import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  LOGIN_FAIL,
  ADMIN_LOADED,
  AUTH_FAIL,
  REGISTER_OTP,
} from "../actions";
import { setAlert } from "./alertAction";
import { useDispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import setAuthToken from "../../Helpers/setAuthToken";
const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

const PROXY = process.env.REACT_APP_URL + "api/";

export const login = (userObj) => async (dispatch) => {
  try {
    const body = JSON.stringify(userObj);
    const res = await axios.post(PROXY + "owner/login", body, config);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });
    dispatch(loadUser());
  } catch (error) {
    dispatch({
      type: LOGIN_FAIL,
    });
    if (error.response) {
      dispatch(setAlert(error.response.data.message, "danger"));
    } else {
      dispatch(setAlert("Error occurred, Please try again later", "danger"));
    }
    return error;
  }
};

// Load User
export const loadUser = () => async (dispatch) => {
  if (localStorage.ownerAppToken) {
    setAuthToken(localStorage.ownerAppToken);
  }

  try {
    const res = await axios.post(PROXY + "owner/auth");

    dispatch({
      type: ADMIN_LOADED,
      payload: res.data,
    });
    return res;
  } catch (error) {
    dispatch({
      type: AUTH_FAIL,
    });
  }
};

export const userRegisterOtp = (userObj) => async (dispatch) => {
  // try {
  const body = JSON.stringify(userObj);
  const res = await axios.post(PROXY + "owner/register-otp", body, config);
  localStorage.setItem("ownerAppToken", res.data.token);
  dispatch(loadUser());
  dispatch({
    type: REGISTER_OTP,
    payload: res.data,
  });

  return res;
  // }
  //  catch (error) {
  //   dispatch({
  //     type: LOGIN_FAIL,
  //   });
  //   toast.error(error.response.data.message);
  //   return error;
  // }
};

export const logout = () => async (dispatch) => {
  dispatch({
    type: LOGOUT_SUCCESS,
  });
};

export const changePassword = (objPassword) => async (dispatch) => {
  const body = JSON.stringify(objPassword);
  try {
    const res = await axios.put(PROXY + "owner/change-password", body, config);
    dispatch(setAlert(res.data.message, "success"));
    return res;
  } catch (error) {
    if (error.response.data.message) {
      dispatch(
        openSnackbar({
          open: true,
          message: error.response.data.message,
          variant: "alert",
          alert: {
            color: "error",
          },
          transition: "Fade",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    } else {
      dispatch(
        openSnackbar({
          open: true,
          message: "Error occurred, Please try again later",
          variant: "alert",
          alert: {
            color: "error",
          },
          transition: "Fade",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    }
  }
};

export const updateProfile = (formData) => async (dispatch) => {
  return await axios.put(PROXY + "owner/update-profile", formData);
};
